export default class LoadMore extends HTMLElement {
    constructor() {
        super();

        this.trigger = this.querySelector("a");
        this.target = this.dataset.loadMore;
        this.targetItems = this.dataset.loadMoreItems;
        this.loadingIndicator = this.querySelector(".loading-indicator");
    }

    connectedCallback() {
        this.trigger.addEventListener("click", this.loadMore.bind(this));

        console.log("LoadMore connected", this);
    }

    disconnectedCallback() {
        this.trigger.removeEventListener("click", this.loadMore.bind(this));
    }

    async loadMore(e) {
        e.preventDefault();

        const url = this.trigger.getAttribute("href");
        const params = new URLSearchParams({ ajax: "true" });
        const targetContainer = document.querySelector(this.target);

        this.trigger.classList.add("is-loading");
        this.trigger.disabled = true;

        this.showSpinner();

        try {
            const response = await fetch(`${url}?${params}`);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const items = doc.querySelectorAll(
                `${this.target} ${this.targetItems}`,
            );

            const loadMore = doc.querySelector(`load-more`);

            items.forEach((item) => targetContainer.appendChild(item));

            this.updateLoadMore(loadMore);
        } catch (error) {
            console.error("Error loading more items:", error);
        } finally {
            this.trigger.classList.remove("is-loading");
            this.trigger.disabled = false;
            this.hideSpinner();
        }
    }

    showSpinner() {
        if (this.loadingIndicator) {
            this.loadingIndicator.setAttribute("active", true);
        }
    }

    hideSpinner() {
        if (this.loadingIndicator) {
            this.loadingIndicator.setAttribute("active", false);
        }
    }

    updateLoadMore(newloadMore) {
        if (newloadMore) {
            this.replaceWith(newloadMore);
        } else {
            this.remove();
        }
    }
}

customElements.define("load-more", LoadMore);

// Export the events for external listeners.
export const { events } = LoadMore;
